import { render } from "./web_categories_field.vue?vue&type=template&id=2f20a249&lang=pug"
import script from "./web_categories_field.vue?vue&type=script&lang=js"
export * from "./web_categories_field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__